import { GET_ALL_EMPLOYEES_SUCCESS, GET_ALL_EMPLOYEES_FAIL, LOGOUT, GET_ALL_EMPLOYEES_REQUEST } from "./types";

import employeeService from "../services/employeeService";

export const getAllEmployees = () => async (dispatch) => {
  dispatch({ type: GET_ALL_EMPLOYEES_REQUEST });
  try {
    const res = await employeeService.getAllEmployees();
    console.log(res.data);
    dispatch({
      type: GET_ALL_EMPLOYEES_SUCCESS,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: GET_ALL_EMPLOYEES_FAIL,
      payload: err.response.data.error,
    });
  }
};